import React from 'react';
import Checkout from './Layouts/Checkout';
import Default from './Layouts/Default';

import Cart from './Cart'
import LoadingSpinner from './LoadingSpinner';

const Layout = ({ children, location }) => {
  
  const isCheckoutPath = location.pathname.startsWith('/checkout');

  return (
    <>
      <LoadingSpinner />
      {isCheckoutPath ? (<Checkout children={children} />) : (<Default children={children} />)}
    </>
  );
}

export default Layout;